import { ConditionalFieldComponent, Type, WithFields } from "../index";
import { FieldRenderProps } from "react-final-form";
import React from "react";

export interface ConditionalFieldOption {
  condition: (v: any, path?: string) => boolean;
  fields: WithFields;
}

export const ConditionalField = (
  conditionalFieldOptions: ConditionalFieldOption[]
) =>
  new Type({
    PresentationComponent: (props: FieldRenderProps<any>) => {
      const v = JSON.stringify(props.input.value);
      return <>{v}</>;
    },
    Component: ConditionalFieldComponent as any,
    props: {
      conditionalFieldOptions
    }
  });
